export default __webpack_public_path__ + "static/media/IconDesc_Fuel.64.23e9645c.png";